<script setup>
import { onUpdated, ref } from 'vue';
import IconWarning from '../../../icons/IconWarning.vue';
import IconSuccess from '../../../icons/IconSuccess.vue';
import IconClose from '../../../icons/IconClose.vue';

const emit = defineEmits(['close']);
const props = defineProps(['args']);
const timeout = ref(null);
const timeoutClose = ref(null);
const isVisible = ref(true);

const formatMessage = () => {
  return Array.isArray(props.args.message)
    ? props.args.message.reduce((prevValue, nextValue) => {
      return `${prevValue} ${nextValue}`;
    }, '')
    : props.args.message;
};

onUpdated(() => {
  clearTimeout(timeout.value);
  clearTimeout(timeoutClose.value);

  timeout.value = setTimeout(() => {
    isVisible.value = false;

    timeoutClose.value = setTimeout(() => {
      emit('close');
      isVisible.value = true;
    }, 0);
  }, 3000);
});
</script>

<template>
  <div :class="`slide-${isVisible ? 'in' : 'out'}-right notification-toast ${props.args.error ? 'notifications--error' : ''}`" v-if="props.args.visible">
    <icon-warning v-if="props.args.error" />
    <icon-success v-else />
    {{ formatMessage() }}
    <div class="notifications__close" @click="() => emit('close')"><icon-close /></div>
  </div>
</template>

<style lang="scss" scoped>
.notification-toast {
  font-family: var(--font);
  z-index: 9999;
  background-color: #fff;
  color: rgba(29, 27, 32, 1);
  position: fixed;
  bottom: 15px;
  right: 15px;
  min-width: 300px;
  border-radius: 5px;
  padding: 24px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  &__close {
    cursor: pointer;
    height: 24px;
  }

  &--error {
    color: #c72e2e;
  }
}
</style>
